import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { audiencesApi } from '../../../api/audiences';
import ExchangesTable from '../../../components/ui/ExchangesTable';

const Exchanges = ({ holders }) => {
  const { id } = useParams();
  const [page, setPage] = useState(1);
  const [desc, setDesc] = useState(true);
  const [orderBy, setOrder] = useState('number_of_users_last_30d');
  const [limit, setLimit] = useState(25);

  const {
    data: exchanges,
    isLoading: isExchnagesLoading,
    isFetching: isExchnagesFetching,
  } = audiencesApi.useGetCustomListExchangeDataQuery({
    address: id,
    limit,
    order: desc ? 'desc' : 'asc',
    orderBy,
    offset: (page - 1) * limit,
  });

  return (
    <ExchangesTable
      data={exchanges}
      totalUsers={holders}
      isLoading={isExchnagesLoading || isExchnagesFetching}
      setPage={setPage}
      setDesc={setDesc}
      setOrder={setOrder}
      setLimit={setLimit}
      page={page}
      limit={limit}
      desc={desc}
      orderBy={orderBy}
    />
  );
};

export default Exchanges;
